import React, { useEffect, useState } from "react";

import { Outlet, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/hooks/store.hooks";
import { verifyRestrictions } from "../store/models/slots/slot.thunk";
import { Loader } from "../components/loader/loader";
import { SlotsBlocked } from "../components/Slots/SlotsBlocked/SlotsBlocked";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { scrollTop } from "../utils/scrollTop";

export const GameLayout = () => {
  const dispatch = useAppDispatch();
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<{ heading: string; text: string } | null>(
    null
  );
  const isDemo = useAppSelector((state) => state.slots.isDemo);
  const { game } = useParams();
  const { t } = useTranslation();
  useEffect(() => {
    scrollTop();
    const verify = async () => {
      if (game) {
        const response = await dispatch(
          verifyRestrictions({ gameId: +game, is_demo: isDemo })
        );
        if (response.type === "verify/fulfilled") {
          debugger;
          if (response.payload?.message) {
            setLoading(false);
            if (response.payload.message === "Game was not provided") {
              setError({
                heading: t("slots.errors.heading.error"),
                text: t("slots.errors.content.invalid_game"),
              });
            } else if (response.payload.message === "Game was not found") {
              setError({
                heading: t("slots.errors.heading.error"),
                text: t("slots.errors.content.invalid_not_found"),
              });
            } else if (response.payload.message === "Wallet was not found") {
              setError({
                heading: t("slots.errors.heading.error"),
                text: t("slots.errors.content.wallet_not_found"),
              });
            } else if (response.payload.message === "Internal error") {
              setError({
                heading: t("slots.errors.heading.error"),
                text: t("slots.errors.content.internal_error"),
              });
            } else if (
              response.payload.message ===
              "Game is not available in this country"
            ) {
              setError({
                heading: t("slots.errors.heading.error"),
                text: t("slots.errors.content.restricted_country"),
              });
            } else if (
              response.payload.message ===
              "Game is not available with this currency"
            ) {
              setError({
                heading: t("slots.errors.heading.error"),
                text: t("slots.errors.content.restricted_currency"),
              });
            } else {
              setError({
                heading: t("slots.errors.heading.error"),
                text: t("slots.errors.content.internal_error"),
              });
            }
          } else if (response.payload.slots) {
            setLoading(false);
            setError({
              heading: t("slots.errors.heading.blocked"),
              text: t("slots.errors.content.blocked"),
            });
          } else {
            setLoading(false);
            setUrl(response.payload.url);
          }
        } else if (response.type === "verify/rejected") {
          setLoading(false);
          setError({
            heading: t("slots.errors.heading.error"),
            text: t("slots.errors.content.internal_error"),
          });
        }
      }
    };
    verify();
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        marginTop: { xs: "56px", sm: "86px" },
        height: {
          xs: "calc(100% - 56px)",
          sm: "calc(100% - 86px)",
        },
      }}
    >
      {error && !loading ? (
        <SlotsBlocked title={error.heading} text={error.text} />
      ) : (
        <Outlet context={{ url }} />
      )}
      {loading && (
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0",
            left: "0",
            zIndex: "2000",
          }}
        >
          <Loader />
        </Box>
      )}
    </Box>
  );
};
